/**
 * An object made up of descriptors which define how the average weekly working time of a driver is calculated
 * regarding Working Time Directive (WTD).
 * See also the DTS API description for further details (Models > DtsWeeklyWorking).
 *
 * @readonly
 * @enum {string}
 */
export const RdtWeeklyWorkingAverageType = Object.freeze({
    NUMBER_OF_MONTHS: 'NUMBER_OF_MONTHS',
    NUMBER_OF_WEEKS: 'NUMBER_OF_WEEKS',
    QUARTER: 'QUARTER'
})
